import { Component, OnInit, Inject } from '@angular/core';
import { IAuthService } from '@src/auth/auth.service.interface';
import { UserRolesEnum } from '@src/model/userRoles';
import { ConfigService } from '@src/services/layout/config.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})

export class DashboardComponent implements OnInit {
  isRetailerDashboard: boolean = false;
  isBetaVersion: boolean;
  hasWarningMessage: boolean;
  
  constructor(@Inject('AuthService')
    private authService: IAuthService,
    private configService: ConfigService) {

  }

  ngOnInit() {
    this.authService.getCurrentUser()
      .subscribe(u =>
        this.isRetailerDashboard = u.isInRole(UserRolesEnum.RETAILER));

    this.isBetaVersion = this.configService.templateConf.isBetaVersion;
    this.hasWarningMessage = this.configService.templateConf.hasWarningMessage;
  }
}
